module.exports = __webpack_public_path__ + "static/media/building_header.5b8d7ab3.png";